import React from 'react';

import { Columns, Column, Box } from '@nerdwallet/currency';
import { ColumnWidth } from '@nerdwallet/currency/dist/components/Columns/Column';
// eslint-disable-next-line lodash/import-scope
import { map, get } from 'lodash';
import num from '@nerdwallet/nw-client-lib/num';

import style from './city-results-table.module.less';

type CityResultsTableProps = {
  data: Record<string, any>;
  config: {
    type: string;
    disclaimerText?: string;
    rows?: Record<string, any>;
  }[];
  tableColumnSize?: ColumnWidth;
};

const CityResultsTable = ({
  data,
  config,
  tableColumnSize = 4,
}: CityResultsTableProps): JSX.Element => {
  const solveEntryName = (row) => {
    let resolvedRowName = '';
    if (row.text) {
      resolvedRowName = row.text;
    } else if (row.type === 'currency') {
      const needsCents = row.formatterStr || row?.formatterStr === '$0.00';
      resolvedRowName = num.formatCurrency(get(data, row.key), needsCents);
    } else if (row.type === 'percent') {
      resolvedRowName = num.formatPercent(
        get(data, row.key),
        row?.formatterStr
      );
    } else {
      resolvedRowName = get(data, row.key);
    }
    return resolvedRowName;
  };

  const isStateName = (entry) => {
    const cities = data?.citiesData;
    return (
      cities &&
      (entry === cities?.destinationCityState ||
        entry === cities?.sourceCityState)
    );
  };

  const getRowEntry = (entry, index, changeColumnSize) => {
    let classname = index === 0 ? style.header : style.entry;
    const resolvedRowName = solveEntryName(entry);
    const columnSize = changeColumnSize ? 12 : tableColumnSize;

    if (entry.key && isStateName(resolvedRowName)) {
      classname = style.city;
    }

    return (
      <Column width={columnSize} key={`col-results-table-entry-${index}`}>
        <Box className={classname}> {resolvedRowName || '\u00a0'}</Box>
      </Column>
    );
  };

  const content = map(config, ({ type, rows, disclaimerText }, index) => {
    if (type === 'disclaimer') {
      return (
        <Box
          className={style.disclaimer}
          key={`col-results-table-disclaimer-${index}`}
        >
          {disclaimerText}
        </Box>
      );
    }
    if (type === 'variable') {
      const rowContent = map(rows, (entry, entryIndex) => {
        return getRowEntry(entry, entryIndex, rows.length === 1);
      });

      return (
        <Box className={style.row} key={`col-results-table-row-${index}`}>
          <Columns alignY="center"> {rowContent} </Columns>
        </Box>
      );
    }
    return null;
  });

  return <Box className={style.table}> {content} </Box>;
};

CityResultsTable.displayName = 'CityResultsTable';

export default CityResultsTable;
